import React from 'react';
import {
  TopToolbar,
  ListButton,
} from 'react-admin';

const RepairEditActions = () => (
  // Overrides the default RA behavior of offering a "Show" option
  // We always want to display the "Edit" view for Under Review statues
  <TopToolbar>
    < ListButton />
  </TopToolbar >
);

export default RepairEditActions;
